export const handleError = (error: any) => {
  console.error('An error occurred:', error);
};
